import { render } from "./ContainerLR.vue?vue&type=template&id=6a5fa143&scoped=true"
import script from "./ContainerLR.vue?vue&type=script&lang=js"
export * from "./ContainerLR.vue?vue&type=script&lang=js"

import "./ContainerLR.vue?vue&type=style&index=0&id=6a5fa143&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cts-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5fa143"]])

export default __exports__